/**
 * Validator for DraftPair action.
 *
 * Rules (§6.3, §11.1, §14):
 *   1. stateVersion matches.
 *   2. Phase is "marketCheck".
 *   3. Slot index is valid (0..3 — guaranteed by type, but we check null presence).
 *   4. Market slot at `slot` has both a tile and a wildlife token (not empty).
 *   5. No auto-wipe is pending (market.autoWipePending === false).
 *
 * Returns ValidationResult with ERR_* codes from §14.
 */

import type { DraftPairAction } from "../types/actions";
import type { ValidationResult } from "../types/common";
import type { GameState } from "../types/game-state";
import { commonGuards, VALID } from "./common-guards";

export const validateDraftPair = (
  state: GameState,
  action: DraftPairAction,
): ValidationResult => {
  const guard = commonGuards(state, action.stateVersion, "marketCheck");
  if (guard !== null) {
    return guard;
  }

  if (state.market.autoWipePending) {
    return {
      valid: false,
      error: "ERR_AUTO_WIPE_PENDING",
      details: { slot: action.slot },
    };
  }

  const slot = state.market.slots[action.slot];
  if (slot.tileInstanceId === null || slot.tokenInstanceId === null) {
    return {
      valid: false,
      error: "ERR_MARKET_SLOT_EMPTY",
      details: { slot: action.slot },
    };
  }

  return VALID;
};
